import { useQuery } from '@tanstack/react-query'
import { IS_WORKFLOW_ENABLED } from 'constants/env'
import { useAuthenticated } from 'modules/auth/handlers'
import { workflowApi } from 'modules/workflow/api'
import { useLastWorkflowDate as getLastWorkflowDate } from 'modules/workflow/store'
import { noRetryOnError } from 'packages/react-query'

import { WorkflowQueries } from './types'

const WF_INDICATOR_REFETCH_INTERVAL_MS = 5000

export const useWFIndicator = () => {
  const { authenticated } = useAuthenticated()
  const enabled = authenticated && IS_WORKFLOW_ENABLED

  const { data, isLoading } = useQuery({
    queryKey: [WorkflowQueries.WorkflowIndicator],
    queryFn: () => workflowApi.getWorkflowIndicator(getLastWorkflowDate.getState().date),
    enabled,
    meta: {
      error: { showToast: false },
    },
    ...noRetryOnError,
    refetchInterval: (query) => (query?.state?.status === 'error' ? false : WF_INDICATOR_REFETCH_INTERVAL_MS),
  })

  return {
    data: !!data?.result,
    isLoading,
  }
}
